import React, { useState, useEffect, useRef } from 'react'

const ButtonWithDropdown = ({ className = '', onClick, label, options = {} }) => {
    const [ shown, setShown ] = useState(false)
    const wrapperRef = useRef(null)
    const triggerRef = useRef(null)

    useEffect(() => {
        const handleClick = (e) => {
            if (
                wrapperRef.current &&
                !wrapperRef.current.contains(e.target) &&
                triggerRef.current &&
                !triggerRef.current.contains(e.target)
            ) {
                setShown(false)
            }
        }

        if (shown) {
            document.addEventListener("mousedown", handleClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, [ shown ])

    const onDropdownClick = (e) => {
        e.stopPropagation()
        setShown(!shown)
    }

    return (
        <div className="button-with-dropdown" style={{ position: "relative" }}>
            <div ref={triggerRef}>
                <button className={`d-flex justify-content-end button-width-dropdown ${className}`}>
                    <span className="align-self-center label" onClick={onClick}>{ label }</span>
                    <span className="dropdown align-self-center" onClick={onDropdownClick} />
                </button>
            </div>
            {shown && (
                <div
                    ref={wrapperRef}
                    className="dropdown-content"
                    style={{
                        position: "absolute",
                        top: "100%",
                        right: 0,
                        zIndex: 1000,
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        minWidth: "150px",
                        marginTop: "4px",
                    }}
                >
                    {options.map((o, no) =>
                        <div
                            className={`dropdown-option ${o.onClick ? 'clickable' : ''}`}
                            onClick={o.onClick}
                            key={no}
                            style={{
                                padding: "8px 12px",
                                cursor: o.onClick ? "pointer" : "default",
                            }}
                            onMouseEnter={(e) => {
                                if (o.onClick) {
                                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                                }
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "transparent";
                            }}
                        >
                            { o.label }
                        </div>
                    )}
                </div>
            )}
        </div>
    )
}

export default ButtonWithDropdown
